import { useState } from 'react'

export const useImageGallery = () => {
  const [modalActive, setModalActive] = useState<boolean>(false)
  const [image, setImage] = useState<string>('')

  const openImageModal = (image: string) => {
    setImage(image)
    setModalActive(true)
  }

  return { modalActive, setModalActive, openImageModal, image }
}
